import { ScrollToTop } from 'utils/ScrollToTop';
import './App.css';
import Routing from './routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getProfileDetails } from './reduxStore/actions/user';
import { isLoggedIn } from 'utils/helpers';

const App = () => {
  const dispatch = useDispatch();
  const isuserLoggedIn = isLoggedIn();

  useEffect(() => {
    if (isuserLoggedIn) {
      dispatch(getProfileDetails())
    }
  }, []);

  return (
    <>
      
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    
      <Routing />
     
    </>
  );
};

export default App;
